/* =================== CADASTRO =================== */
$(function () {
  var enviando_formulario = false;
  $("#form-cadastro").on("submit", function (e) {
    e.preventDefault();

    var obj = this;
    var form = $(obj);
    var submit_btn = $("#cadastrar");
    var submit_btn_text = submit_btn.text();
    var dados = new FormData(obj);

    function volta_submit() {
      submit_btn.attr("disabled", false);
      submit_btn.text(submit_btn_text);
      enviando_formulario = false;
      //hideLoading();
    }

    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          //showLoading();
          enviando_formulario = true;
          submit_btn.attr("disabled", true);
          submit_btn.text("Aguarde...");
        },
        success: function (data) {
          console.log(data);
          volta_submit();
          if (data == "ok") {
            $("#form-cadastro .campo").val("");
            window.location.href = $("#cadastro_retorno").val();
          } else if (data == "erro-cod") {
            showAlert('Erro', 'Tente novamente, código não correspondente.', 'error');
          } else {
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        },
      });
    }
  });
});

/* =================== AUTENTICADOR =================== */

var codigo1 = 0;
var codigo2 = 0;
var codigo3 = 0;
var codigo4 = 0;

jQuery(document).ready(function ($) {

  $('.emailcod').on('change', function (e) {
    $('.opt-login-hide').show('slow');
    enviaCod();
    intervals.forEach(clearInterval);
    ativaTimer();
  });

  function enviaCod() {
    var obj = $('#form-cadastro');
    var dados = new FormData(obj[0]);
    $.ajax({
      type: "POST",
      url: url_base + 'acoes/app/usuarios/cod_email_envia.php',
      data: dados,
      processData: false,
      cache: false,
      contentType: false,
      success: function (resposta) {
        $('.campo-auth input').css('border-color', '#e75f67');
        $('.campo-auth').removeClass('valid');
        $("#campo1").val('');
        $("#campo2").val('');
        $("#campo3").val('');
        $("#campo4").val('');
      }
    });
  }

  var intervals = [];
  function ativaTimer() {
    $("#tempo").html('60');
    $("#frase-codigo").show();
    $("#reeviar-cod").hide();
    var counter = 60;
    var interval = setInterval(function () {
      counter--;
      if (counter <= 0) {
        clearInterval(interval);
        $("#frase-codigo").hide();
        $("#reeviar-cod").show();
        return;
      } else {
        $("#tempo").text(counter);
      }
    }, 1000);
    intervals.push(interval);
  }

  $('#reeviar-cod').on('click', function (e) {
    enviaCod();
    intervals.forEach(clearInterval);
    ativaTimer();
  });


  $("#campo1").keyup(function (e) {
    if ($("#campo1").val() != "") {
      // $("#campo2").focus();
    }
    codigo1 = $("#campo1").val();
    if ($("#campo1").val().length == 4) {
      VerificaCampos();
    }
  });
  /* $("#campo2").keyup(function (e) {
    if ($("#campo2").val() != "") {
      codigo2 = $("#campo2").val();
    }
    //$("#campo3").focus();
    VerificaCampos();
  });
  $("#campo3").keyup(function (e) {
    if ($("#campo3").val() != "") {
      codigo3 = $("#campo3").val();
    }
    //$("#campo4").focus();
    VerificaCampos();
  });
  $("#campo4").keyup(function (e) {
    //codigo4 = $("#campo4").val();
    VerificaCampos();
  }); */
});

function cancatenaCod() {
  var listaCodigos = codigo1 /* + codigo2 + codigo3 + codigo4 */;
  $("#verifica_codigo").val(listaCodigos);
  var obj = $('#form-cadastro');
  var dados = new FormData(obj[0]);
  $.ajax({
    type: "POST",
    url: url_base + 'acoes/app/usuarios/cod_email_verifica.php',
    data: dados,
    processData: false,
    cache: false,
    contentType: false,
    success: function (resposta) {
      if (resposta == "ok") {
        $('.campo-auth input').css('border-color', '#00d248');
        $('.campo-auth').addClass('valid');
      } else {
        showAlert('Erro', 'Tente novamente, código não correspondente.', 'error');
        $('.campo-auth input').css('border-color', '#e75f67');
        $('.campo-auth').removeClass('valid');
      }
    }
  });
}

function VerificaCampos() {
  if (
    $("#campo1").val() != ""/*  &&
    $("#campo2").val() != "" &&
    $("#campo3").val() != "" &&
    $("#campo4").val() != "" */
  ) {
    cancatenaCod();
  }
}

